import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-title-section-list',
  templateUrl: './title-section-list.component.html',
  styleUrls: ['./title-section-list.component.css'],
})
export class TitleSectionListComponent implements OnInit {
  @Input() title: String = '';
  @Input() desc1: String = '';
  @Input() desc2: String = '';
  @Input() link: String = '';
  @Input() linkText: String = '';

  constructor() {}

  ngOnInit(): void {}
}
